class MFRDivider {
  constructor( i, e ) {
    this.$index = i;
    this.$element = $( e );

    this.selectors = {
      
    }

    this.lottieURL = this.$element.data( "lottie-url" );

    this.init();
  }

  init() {
    if( typeof lottie === "undefined" ) return;
    this.animation = lottie.loadAnimation({
      container: this.$element.get(0),
      renderer: "svg",
      loop: true,
      autoplay: true,
      path: this.lottieURL,
      rendererSettings: {
        preserveAspectRatio: "xMidYMax slice",
      },
    });
  }
}

jQuery( () => {
  $("[data-lottie-url]").each( (i,e) => {
    const mfrDivider = new MFRDivider( i, e );
  } );
} );